module.exports = __webpack_public_path__ + "img/d- (14).08360f74.png";